import { useEffect, useState, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { ArrowsOut, ArrowsIn } from "@phosphor-icons/react";
import api from "../lib/api";
import { useRealtime } from "../hooks/useRealtime";
import CourtScoreboard from "../components/CourtScoreboard";

// Public per-court fullscreen screen. Always shows the current match on the court
// and auto-updates in real time (no reload needed).
export default function CourtScreen() {
  const { courtId } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [isFs, setIsFs] = useState(false);
  const rootRef = useRef(null);

  const load = useCallback(() => {
    api.get(`/courts/${courtId}/current`)
      .then((r) => setData(r.data))
      .catch(() => setNotFound(true));
  }, [courtId]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const onChange = () => setIsFs(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const toggleFs = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    } else if (rootRef.current?.requestFullscreen) {
      rootRef.current.requestFullscreen().catch(() => {});
    }
  };

  useRealtime(useCallback((msg) => {
    if (msg.type === "refresh" || msg.type === "branding") return load();
    if (msg.type === "match_update" && msg.match && msg.match.court_id === courtId) {
      setData((prev) => (prev ? { ...prev, match: msg.match } : prev));
    }
  }, [load, courtId]));

  if (notFound) return <div className="h-screen flex items-center justify-center text-muted-foreground font-heading uppercase tracking-widest">Cancha no encontrada</div>;
  if (!data) return <div className="h-screen flex items-center justify-center text-padel-blue font-heading uppercase animate-pulse-glow">Cargando…</div>;

  return (
    <div ref={rootRef} className="h-screen w-screen overflow-hidden">
      <CourtScoreboard
        match={data.match}
        court={data.court}
        headerRight={
          <button
            data-testid="court-screen-fullscreen-btn"
            onClick={toggleFs}
            title={isFs ? "Salir de pantalla completa" : "Pantalla completa"}
            className="p-3 text-muted-foreground hover:text-padel-green transition-colors"
          >
            {isFs ? <ArrowsIn size={30} /> : <ArrowsOut size={30} />}
          </button>
        }
      />
    </div>
  );
}
